import React from 'react';
import html2canvas from 'html2canvas';
import TextWinds from '../common/TextWinds';
import Buttons from '../button/Buttons2';
import { CertificateImgEnum } from '../../constants/types/mypage-type';

interface CertificateImgType {
  name: string;
  type: CertificateImgEnum;
  date: string;
  readonly?: boolean;
}
const CertificateImg = ({
  name,
  type,
  date,
  readonly = false,
}: CertificateImgType) => {
  const printImg = (id: string) => {
    console.log('type', type);
    const imageDiv = document.getElementById(id);
    imageDiv!.style.display = 'block';

    const style = document.createElement('style');
    document.head.appendChild(style);
    style.sheet?.insertRule(
      'body > div:last-child img { display: inline-block; }',
    );

    const img = html2canvas(imageDiv, { scale: 10 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      // **다운 받지 않고 브라우저 확인용**
      // sample.current!.src = imgData;
      const link = document.createElement('a');
      link.href = imgData;
      const fileName = generateFileName(name, type);
      link.download = fileName;
      link.click();
    });
  };
  // **다운 받지 않고 브라우저 확인용**
  // const sample = useRef<HTMLImageElement>(null);

  const getImgURL = (type: CertificateImgEnum) => {
    return process.env.PUBLIC_URL + `/images/mypage/certification/${type}.png`;
  };

  const generateFileName = (name: string, courseType: string) => {
    // 공백을 언더스코어로 변환
    const normalizedName = name.replace(/\s+/g, '_');
    const normalizedCourse = courseType.replace(/\s+/g, '_');

    return `JEBS_LICENSE_${normalizedName}_${normalizedCourse}.png`;
  };
  return (
    <>
      {/* // **다운 받지 않고 브라우저 확인용** */}
      {/* <img ref={sample} src="" width={300} height={100}/> */}
      <div className="rounded-md border border-gray-400 p-1">
        <div id={`${name}${date}`}>
          <div className="relative">
            <img
              src={getImgURL(type)}
              alt={name}
              className="w-[250px] max-w-[250px]"
            />
            <h1 className="title absolute left-0 top-[156px] w-full text-center text-[20px] leading-6 [overflow-wrap:break-word]">
              {name}
            </h1>
            <h2 className="date absolute left-[46px] top-[278px] w-full text-[9px]">
              {date}
            </h2>
          </div>
        </div>
        {!readonly && (
          <div className="flex justify-between">
            <div>
              <TextWinds
                type="content_body3"
                xlType="sub_title01"
                className="max-w-[150px] truncate"
              >
                {name}
              </TextWinds>
              <TextWinds type="caption1" xlType="content_body4" color="gray8">
                발급일 {date}
              </TextWinds>
            </div>
            <Buttons
              variant="text"
              color="purple5"
              type="text"
              onClick={() => printImg(`${name}${date}`)}
            >
              <TextWinds type="button2" color="purple5">
                다운로드
              </TextWinds>
            </Buttons>
          </div>
        )}
      </div>
    </>
  );
};

export default CertificateImg;
